import setSliderPosition from './slider';

const onDrag = event => {
  const pageX = event.changedTouches
    ? event.changedTouches[0].pageX
    : event.pageX;

  setSliderPosition(pageX);
};

const onDragEnd = () => {
  document.removeEventListener('mousemove', onDrag);
  document.removeEventListener('mouseup', onDragEnd);
};

const onTouchEnd = () => {
  document.removeEventListener('touchmove', onDrag);
  document.removeEventListener('touchend', onTouchEnd);
};

export const onDragStart = () => {
  document.addEventListener('mousemove', onDrag);
  document.addEventListener('mouseup', onDragEnd);
};

export const onTouchStart = () => {
  document.addEventListener('touchmove', onDrag);
  document.addEventListener('touchend', onTouchEnd);
};
